import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageService } from "../services";

export const PublicRoute = () => {
  const location = useLocation();

  const isAuthenticated = () => {
    const token = localStorageService.getItem<string>("token");
    return !!token;
  };

  if (isAuthenticated() && ["/login", "/signup"].includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
